import { BigNumber } from '@ethersproject/bignumber';

// @dev: replace this value with the name of the widget you're building
//       (ex: m-widget-connect, m-burn-redeem-complete, etc.)
export const DATA_WIDGET_VALUE = 'm-burn-redeem-complete';

// common events
export const AUTHENTICATED = 'm-authenticated';
export const UNAUTHENTICATED = 'm-unauthenticated';

export const BURN_FEE = BigNumber.from('690000000000000');
export const MULTI_BURN_FEE = BigNumber.from('990000000000000');
export const NULL_BYTES32 = '0x0000000000000000000000000000000000000000000000000000000000000000';

export type DataClientNFT = {
  contractAddress: string;
  tokenId: string;
  ownerAddress: string;
  name: string;
  image: string;
  spec: string;
  count: string;
};

export type Step = {
  name: string;
  description?: string;
  href?: string;
  status: 'current' | 'next' | 'complete';
};
